const fields = `
  revision
  owners { id name enabled credentialsConfigured credentials { publicKey privateKey integrity events } }
  brands { brand methods { method allocations { ownerId enabled percentage } } }
`

export default {
  HISTORY: `query getPaymentHistory {
    getPaymentHistory {
      previousMonth currentMonth updatedAt
      brands {
        brand
        previous { ownerId ownerName method value count }
        current { ownerId ownerName method value count }
      }
    }
  }`,
  GET: `query getPaymentConfig { getPaymentConfig { ${fields} } }`,
  UPDATE: `mutation updatePaymentConfig($config: PaymentConfigurationInput!) {
    updatePaymentConfig(config: $config) { ${fields} }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/paymentConfig.js